import {
  LuSunMoon,
  LuSun,
  LuMoon 
} from "react-icons/lu";

export const appearanceColorSchemes = [
  {
    id: "system",
    label: "System",
    icon: LuSunMoon,
  },
  {
    id: "light",
    label: "Światło",
    icon: LuSun,
  },
  {
    id: "dark",
    label: "Ciemność",
    icon: LuMoon,
  },
];